import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useHaptics } from './useHaptics';

export const useSwipeBack = () => {
    const navigate = useNavigate();
    const { trigger } = useHaptics();

    // Store touch start position
    const touchStart = useRef<number | null>(null);
    const touchY = useRef<number | null>(null);

    useEffect(() => {
        const handleTouchStart = (e: TouchEvent) => {
            // Only consider swipes starting from the very left edge (30px)
            if (e.touches[0].clientX < 30) {
                touchStart.current = e.touches[0].clientX;
                touchY.current = e.touches[0].clientY;
            } else {
                touchStart.current = null;
            }
        };

        const handleTouchEnd = (e: TouchEvent) => {
            if (touchStart.current === null) return;

            const touchEnd = e.changedTouches[0].clientX;
            const touchEndY = e.changedTouches[0].clientY;

            // Calculate deltas
            const deltaX = touchEnd - touchStart.current;
            const deltaY = Math.abs(touchEndY - (touchY.current || 0));

            // Logic:
            // 1. Must be a significant horizontal swipe (> 100px)
            // 2. Must be mostly horizontal (deltaX > deltaY * 2) to avoid scrolling conflict
            if (deltaX > 100 && deltaX > deltaY * 2) {
                trigger('light'); // Feedback
                navigate(-1); // Go back
            }

            // Reset
            touchStart.current = null;
            touchY.current = null;
        };

        document.addEventListener('touchstart', handleTouchStart);
        document.addEventListener('touchend', handleTouchEnd);

        return () => {
            document.removeEventListener('touchstart', handleTouchStart);
            document.removeEventListener('touchend', handleTouchEnd);
        };
    }, [navigate, trigger]);
};
